import styled, { keyframes } from 'styled-components';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFile';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import { Button } from '@mui/material';
import LoopIcon from '@mui/icons-material/Loop';

const TEAL = '#0F6E56';
const TEAL_LIGHT = '#E1F5EE';

const FileIcon = styled(UploadFileOutlinedIcon)`
  font-size: 20px !important;
`;
const CameraIcon = styled(CameraAltOutlinedIcon)`
  font-size: 20px !important;
`;

/* Antes: width fixo 400px. Agora responsivo.
   Mobile: 2 colunas (câmera + arquivo). Desktop: 1 coluna. */
const InputArea = styled.div`
  margin: 24px auto 0;
  width: 100%;
  max-width: 360px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  &[data-desktop='true'] {
    grid-template-columns: 1fr;
    max-width: 420px;
  }
`;

const OptionPill = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  border-radius: 10px;
  background: ${TEAL_LIGHT};
  color: ${TEAL};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s;

  &:hover {
    background: #d2efe5;
  }
`;

const InputHint = styled.p`
  margin: 10px auto 0;
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
`;

const InputFile = styled.input`
  display: none;
`;

/* ---------- Lista de arquivos (visual) ---------- */
const FileList = styled.div`
  width: 100%;
  max-width: 360px;
  margin: 18px auto 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  border: 2px solid #ededed;
  border-radius: 12px;
  padding: 8px 10px;
  animation: ${fadeIn} 0.18s ease;
`;

const FileIconBox = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 9px;
  background: ${TEAL_LIGHT};
  color: ${TEAL};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const FileInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

const FileName = styled.a`
  display: block;
  font-size: 13px;
  color: #9ca3af;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s;
  font-weight: 600;
  &:hover {
    color: ${TEAL};
  }
`;

const FileMeta = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
  font-size: 11px;
  color: #9ca3af;
`;

const InputAreaDetailing = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  width: 400px;
`;
const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 150px;
  text-align: center;
`;
const WebCanContainer = styled.div`
  position: absolute;
  z-index: 10;
  top: 100px;
  display: flex;
  flex-direction: column;
`;
const WebCanButtonContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
`;
const WebcanButton = styled(Button)`
  margin-left: 20px !important;
`;
const CameraSwitcher = styled(LoopIcon)`
  margin-right: auto;
  margin-left: 40px;
  cursor: pointer;
  display: inline-block;
`;
const LinkImage = styled.a`
  text-decoration: none;
  color: #204ff6;
`;

const indeterminate = keyframes`
  0%   { left: -40%; width: 40%; }
  50%  { left: 30%;  width: 50%; }
  100% { left: 100%; width: 40%; }
`;

const ProgressTrack = styled.div`
  position: relative;
  height: 5px;
  border-radius: 3px;
  background: ${TEAL_LIGHT};
  overflow: hidden;
  margin-top: 6px;
`;

const ProgressBar = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  border-radius: 3px;
  background: ${TEAL};
  animation: ${indeterminate} 1.1s ease-in-out infinite;
`;

export {
  FileIcon,
  CameraIcon,
  InputArea,
  OptionPill,
  InputHint,
  InputFile,
  FileList,
  FileRow,
  FileIconBox,
  FileInfo,
  FileName,
  FileMeta,
  IconContainer,
  InputAreaDetailing,
  WebCanContainer,
  WebCanButtonContainer,
  WebcanButton,
  ProgressTrack,
  ProgressBar,
  CameraSwitcher,
  LinkImage,
};